module.exports = __webpack_public_path__ + "img/zdgz.fca843d.png";